export const environment = {
  url: {
    api: `https://apim-uat.houseofhr.com/square-app-prodigy/api/v2.0`,
  },
  production: true,
  ocpApimSubscriptionKey: '8ab4849fc52943e6b24cbe706246fc91'
};

